import {Header} from "../../components/SharedPageComponents/Header/Header";
import {Footer} from "../../components/SharedPageComponents/Footer/Footer";
import {Copyrights} from "../../components/SharedPageComponents/Copyrights/Copyrights";
import {Outlet} from "react-router-dom";
import {PageWrapper} from "./styled";

export const SharedLayout = () => {
    return (
        <>
            <Header/>
            <PageWrapper>
                <Outlet/>
            </PageWrapper>
            <Footer/>
            <Copyrights/>
        </>
    )
}
